import { SyntheticEvent } from "react";
import { Component } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";

import { Props } from "../propTypes";
import { childFormComponent } from "./types";
import classnames from "classnames";
import { ObjectLiteral } from "../../constants";
import { ProgressIndicator } from "./ProgressIndicator";
import { withCookies } from "react-cookie";
import { ResetForm } from "./ResetForm";

// TshirtSize Form Component
/**
 * This component is used to input and store a user's campus information in MyElevation.
 *
 * We are using the Form and Button components from Semantic UI React Library.
 * For more information on these components can be found at https://react.semantic-ui.com/collections/form/
 * and https://react.semantic-ui.com/elements/button/
 *
 * The campus values are being pulled from this.props.actions.main.main_get_all_campuses().
 * Check this action and the api calls set up within them if you run into any problems.
 */

type State = {
    tshirtSize: string;
    tshirtSizeFocused: boolean;
};

class TshirtSize extends Component<Props & childFormComponent, State> {
    state = {
        tshirtSize: "",
        tshirtSizeFocused: false,
    };

    // Component Did Mount Lifecycle Method
    /**
     * componentDidMount() runs immediately after the component mounts.
     */
    componentDidMount() {
        if (
            !this.props.main.tshirtSizes ||
            (this.props.main.tshirtSizes &&
                this.props.main.tshirtSizes.length < 1)
        ) {
            this.props.actions.main.main_get_tshirt_size_list();
        }
    }

    // Save and Continue Function
    /**
     * saveAndContinue() saves the values to the state and goes to the corresponding next step.
     */
    saveAndContinue = (e: any) => {
        e.preventDefault();

        this.props.nextStep(6);
    };

    render() {
        return (
            <>
                <div className="col-xs-12 max-w-500 center-content m-b-spacer-3xl full-width">
                    <h2 className="text-dark text-left no-bottom-margin m-b-spacer-none font-size-24 text-center">
                        What&#39;s your T-Shirt size?
                    </h2>
                    <p className="text-dark half-here no-top-margin m-b-spacer-lg text-center">
                        We’ll have a shirt ready for you along with everything
                        you need to get baptized.
                    </p>
                    <Form>
                        <Form.Field
                            className={classnames(
                                "label-animation-input rel-pos flex flex-column full-width m-b-spacer-lg",
                                {
                                    filled:
                                        this.state.tshirtSize ||
                                        this.state.tshirtSizeFocused,
                                }
                            )}
                        >
                            <label style={{ zIndex: 2 }}>T-Shirt Size</label>
                            <Dropdown
                                fluid
                                selection
                                options={this.props.main.tshirtSizes.map(
                                    (size) => {
                                        return {
                                            key: size,
                                            text: size,
                                            value: size,
                                        };
                                    }
                                )}
                                onChange={(
                                    event: SyntheticEvent,
                                    data: ObjectLiteral
                                ) => {
                                    this.props.handleChange("tshirtSize")(
                                        undefined,
                                        data.value
                                    );
                                    if (data.value) {
                                        this.setState({
                                            tshirtSize: data.value,
                                        });
                                    } else {
                                        this.setState({
                                            tshirtSizeFocused: false,
                                        });
                                    }
                                }}
                                onClick={() => {
                                    this.setState({ tshirtSizeFocused: true });
                                }}
                                onBlur={() => {
                                    this.setState({ tshirtSizeFocused: false });
                                }}
                                disabled={this.props.values.isLoading}
                                onFocus={(e) => {
                                    (e.target as any).setAttribute(
                                        "autocomplete",
                                        "nope"
                                    );
                                }}
                                value={this.state.tshirtSize}
                                className="p-x-spacer-md ec-border-radius-sm b-width-xs text-alt-dark-grey full-width"
                                name="tshirtSize"
                            />
                        </Form.Field>

                        {this.props.values.isLoading ? (
                            <div className="form-loading rel-pos  m-t-spacer-md  way-forward full-width uptop">
                                <div className="la-ball-clip-rotate la-color la-md loading-spin abs-pos absolute-center">
                                    <div />
                                </div>
                            </div>
                        ) : (
                            <Button
                                className="full-width no-border text-white  p-y-spacer-md uppercase let-sp-reg hover-grow ec-border-radius-sm"
                                onClick={this.saveAndContinue}
                                disabled={!this.state.tshirtSize}
                                id={`${this.props.tagPrefixId}-tshirt-size-next`}
                            >
                                Next
                            </Button>
                        )}
                    </Form>
                    <div className="m-t-spacer-lg">
                        <ProgressIndicator
                            currentStep={this.props.values.step}
                        />
                    </div>
                </div>
                <ResetForm
                    idPrefix={`${this.props.tagPrefixId}-tshirt-size`}
                    cancelUrl={this.props.cancelUrl || ""}
                />
            </>
        );
    }
}

export default withCookies(TshirtSize);
